import * as React from 'react'

import { Box, Popover, Tag, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import MinutesToText from 'modules/attendance/components/MinutesToText'

const PlannedHoursTag = ({
  balanceFromPlanning,
  estimatedOvertimeMinutes,
}: {
  balanceFromPlanning: number
  estimatedOvertimeMinutes: number
}) => {
  const [hover, setHover] = React.useState<boolean>(false)
  const tagText =
    estimatedOvertimeMinutes > 0
      ? i18n.t('clock_in.bank_of_hours.counters.planned_hours.tag_description')
      : i18n.t('clock_in.bank_of_hours.counters.planned_hours.tag_description_with_overtime')

  return (
    <Box paddingY="s4" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <Popover.ItemList
        gapDivider={false}
        attachment="bottom center"
        open={hover}
        toggle={() => () => undefined}
      >
        <Tag type={Tag.Types.radical} leftItem="icon" icon="alert-circle">
          {
            <MinutesToText
              color="grey1000"
              size="200"
              weight="medium"
              value={balanceFromPlanning}
            />
          }
        </Tag>
        <Box textAlign="left">
          <Text color="grey000White" weight="medium" size="200">
            {tagText}
          </Text>
        </Box>
      </Popover.ItemList>
    </Box>
  )
}

export default PlannedHoursTag
